import type { IconProps } from './../../models/icon';

export function LinkedInIcon({
  width = 24,
  height = 24,
  className,
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 1C2.79086 1 1 2.79086 1 5V19C1 21.2091 2.79086 23 5 23H19C21.2091 23 23 21.2091 23 19V5C23 2.79086 21.2091 1 19 1H5ZM6.20455 7.90909C7.14594 7.90909 7.90909 7.14594 7.90909 6.20455C7.90909 5.26315 7.14594 4.5 6.20455 4.5C5.26315 4.5 4.5 5.26315 4.5 6.20455C4.5 7.14594 5.26315 7.90909 6.20455 7.90909ZM7.90909 19.5V9.27273H4.5V19.5H7.90909ZM12.3409 9.27273H9.27273V19.5H12.3409V13.3304C12.7362 12.6876 13.418 12 14.3864 12C15.75 12 16.0909 13.3636 16.0909 14.0455V19.5H19.5V14.0455C19.5 12.2184 18.7025 9.27273 15.75 9.27273C13.8721 9.27273 12.8294 9.95784 12.3409 10.5996V9.27273Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
